import { useMemo } from 'react';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { required } from 'helpers/validators';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { useAccessorEquipmentOptions } from './hooks';
import { AccessorFormModel, AccessorFormValues } from './types';
import { normalizeEquipmentId } from './utils';

interface AccessorFormParams {
  accessor?: AccessorFormModel;
  onSubmit: (values: AccessorFormValues) => Promise<void> | void;
  isDisabledEdit?: boolean;
}
function AccessorForm(params: AccessorFormParams) {
  const { t } = useTranslation();
  const { equipments } = useAccessorEquipmentOptions();

  const { accessor, onSubmit, isDisabledEdit } = params;
  const isEdit = Boolean(
    accessor && typeof accessor === 'object' && 'id' in accessor && accessor.id != null
  );

  const equipmentId = normalizeEquipmentId(accessor?.equipment);
  const equipmentInit = useMemo(
    () => (equipmentId != null ? equipments.find((eq) => eq.id === equipmentId) : undefined),
    [equipments, equipmentId]
  );

  const formInitialValues =
    isEdit && accessor
      ? {
          code: accessor.code,
          description: accessor.description,
          serial_number: accessor.serial_number,
          equipment: equipmentId ?? ''
        }
      : undefined;

  if (!accessor) return null;

  return (
    <ReactFinalForm
      key={`accessor-form-${'id' in accessor && accessor.id != null ? accessor.id : 'new'}-${
        equipments.length
      }`}
      onSubmit={onSubmit}
      edit={isEdit}
      initialValues={formInitialValues}>
      <div className="flex flex-wrap">
        <div className="w-full md:w-1/2 p-2">
          <IdentityField
            name="code"
            initialValue={accessor.code}
            component={TextFieldAdapter}
            label={t('global.code')}
            type="text"
            validate={required}
            disabled={isDisabledEdit}
            required
          />
        </div>

        <div className="w-full md:w-1/2 p-2">
          <IdentityField
            name="description"
            initialValue={accessor.description}
            component={TextFieldAdapter}
            label={t('global.description')}
            type="text"
            validate={required}
            disabled={isDisabledEdit}
            required
          />
        </div>

        <div className="w-full md:w-1/2 p-2">
          <IdentityField
            name="serial_number"
            initialValue={accessor.serial_number}
            component={TextFieldAdapter}
            label={t('global.serial_number')}
            type="text"
            validate={required}
            disabled={isDisabledEdit}
            required
          />
        </div>

        <div className="w-full md:w-1/2 p-2">
          <IdentityField
            name="equipment"
            component={AutocompleteAdapter}
            options={equipments}
            initValue={equipmentInit}
            optionLabel="code"
            placeholder={t('global.equipment')}
            type="text"
            disabled={isDisabledEdit}
            required
            autoSelect={false}
          />
        </div>
        {/* 
            {accessor.id && accessor.equipment && (
              <div className="w-full md:w-1/2 p-2">
                <IdentityField
                  name="contract_equipment"
                  component={TextFieldAdapter}
                  initialValue={`${ticket['equipment_description']} (SN ${ticket['serial_number']}) - (ID. ${ticket['internal_id']})`}
                  options={equipments}
                  placeholder={t('global.equipment')}
                  type="text"
                  disabled={true}
                />
              </div>
            )} */}
      </div>
    </ReactFinalForm>
  );
}

export default AccessorForm;
